"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var material_1 = require("@angular/material");
var wf_permissions_helper_service_1 = require("../service/wf-permissions-helper.service");
var permission_1 = require("../model/permission");
var multi_conditional_permission_two_level_1 = require("./model/multi-conditional-permission-two-level");
var conditional_permission_two_level_1 = require("./model/conditional-permission-two-level");
var setup_permissions_as_component_1 = require("../dialogs/setup-as-dialog/setup-permissions-as.component");
var export_wf_permissions_service_1 = require("../service/export-wf-permissions-service");
var workflow_base_control_component_1 = require("../workflow-base-control.component");
// tslint:disable
var WfPermissionsTwoLevelComponent = /** @class */ (function (_super) {
    __extends(WfPermissionsTwoLevelComponent, _super);
    function WfPermissionsTwoLevelComponent(currentLanguageProvider, classifierService, actionService, stateService, processService, kbService, helperService, exportDataService, dialog) {
        var _this = _super.call(this, currentLanguageProvider) || this;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.classifierService = classifierService;
        _this.actionService = actionService;
        _this.stateService = stateService;
        _this.processService = processService;
        _this.kbService = kbService;
        _this.helperService = helperService;
        _this.exportDataService = exportDataService;
        _this.dialog = dialog;
        // Public
        _this.firstClassifierLabel = 'cms_first_classifier';
        _this.secondClassifierLabel = 'cms_second_classifier';
        return _this;
    }
    WfPermissionsTwoLevelComponent_1 = WfPermissionsTwoLevelComponent;
    WfPermissionsTwoLevelComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        var wfStates$ = Observable_1.Observable.fromPromise(this.stateService.getAllStates());
        var wfActions$ = Observable_1.Observable.fromPromise(this.actionService.getActions());
        var wfProcesses$ = Observable_1.Observable.fromPromise(this.processService.getProcesses());
        var metaFields$ = this.kbService.getMetaFields(this.category);
        var firstClassifier$ = metaFields$.pipe(operators_1.switchMap(function (fields) {
            _this._firstClassifierCategory = fields.find(function (value) { return value.getSystemName() === _this.firstClassifierField; }).getCompoundCategorySystemName();
            return _this.classifierService.loadClassifiersView(_this._firstClassifierCategory);
        }));
        var secondClassifier$ = metaFields$.pipe(operators_1.switchMap(function (fields) {
            _this._secondClassifierCategory = fields.find(function (value) { return value.getSystemName() === _this.secondClassifierField; }).getCompoundCategorySystemName();
            return _this.kbService.getMetaFields(_this._secondClassifierCategory);
        }), operators_1.switchMap(function (secondClassifierFields) {
            var secondClassifierParentMetaField = secondClassifierFields.find(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.PARENT &&
                field.getCompoundCategorySystemName() === _this._firstClassifierCategory; });
            if (secondClassifierParentMetaField) {
                _this._isHierarchical = true;
                _this._secondClassifierParentMetaFieldId = secondClassifierParentMetaField.getMetaFieldId();
            }
            return _this.classifierService.loadAllClassifiers(_this._secondClassifierCategory);
        }), operators_1.map(function (value) { return value.getData(); }));
        var roles$ = this.helperService.getRoles(this.roleIds).pipe(operators_1.map(function (roles) {
            _this.rolesMap = WfPermissionsTwoLevelComponent_1.constructRolesMap(roles);
            return roles
                .map(function (role) { return WfPermissionsTwoLevelComponent_1.constructClassifier(role.id, role.properties['name']); })
                .sort(function (a, b) { return a.name.localeCompare(b.name); });
        }));
        var conditionalPermissions$ = this.helperService.getCategoryConditionalPermissions(this.category);
        var matrix$ = this.helperService.getMatrix(this.category);
        var keysMatrix$ = this.helperService.getKeysMatrix(this.category);
        Observable_1.Observable.zip(wfStates$, wfActions$, firstClassifier$, secondClassifier$, roles$, conditionalPermissions$, matrix$, keysMatrix$, wfProcesses$)
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function (data) {
            _this.processId = data[8]
                .find(function (value) { return value.getCategorySystemName() === _this.category; }).getId();
            var filteredStates = data[0]
                .filter(function (state) { return state.getProcessId() === _this.processId; });
            var filteredActions = data[1]
                .filter(function (action) { return filteredStates.findIndex(function (state) { return state.getId() === action.getInitialStateId(); }) !== -1; });
            _this.wfStates = filteredStates
                .filter(function (state) { return filteredActions.some(function (action) { return action.getInitialStateId() === state.getId(); }); })
                .map(function (value) { return WfPermissionsTwoLevelComponent_1.constructClassifier(value.getId(), value.getName().getValue(_this.currentLanguageId)); });
            _this.wfActions = filteredActions.map(function (value) { return WfPermissionsTwoLevelComponent_1.constructClassifier(value.getId(), value.getName().getValue(_this.currentLanguageId)); });
            _this.wfActionsByState = WfPermissionsTwoLevelComponent_1.initWfActionsByState(filteredActions, _this.currentLanguageId);
            _this.wfStateByAction = WfPermissionsTwoLevelComponent_1.initWfStateByAction(filteredActions, _this.wfStates);
            _this.wfProcessByAction = WfPermissionsTwoLevelComponent_1.initWfProcessByAction(data[0], data[1]);
            _this.wfTransitions = WfPermissionsTwoLevelComponent_1.initWfTransitions(_this.wfActionsByState, filteredActions, filteredStates, _this.currentLanguageId);
            _this.dataSource = new material_1.MatTableDataSource(_this.wfTransitions);
            _this.firstClassifiers = data[2];
            _this._secondClassifiers = _this._isHierarchical ?
                WfPermissionsTwoLevelComponent_1.prepareHierarchy(data[2], data[3], _this._secondClassifierParentMetaFieldId, _this.currentLanguageId) :
                WfPermissionsTwoLevelComponent_1.prepareNonHierarchy(data[2], data[3], _this.currentLanguageId);
            _this.roles = data[4];
            _this.permissions = WfPermissionsTwoLevelComponent_1.initPermissionOptions(_this.currentLanguageId, data[5]);
            _this._permissionsByCondition = WfPermissionsTwoLevelComponent_1.fromMatrix(data[6], _this.permissions);
            _this._permissionsByConditionChanged = new Map();
            _this.permissionKeyByRoleAndAction = WfPermissionsTwoLevelComponent_1.fromKeysMatrix(data[7]);
            _this._selectedRoleId = _this.roles[0].getId();
            _this._selectedFirstClassifierId = _this.firstClassifiers[0].getId();
            _this._selectedSecondClassifier = _this._secondClassifiers.get(_this._selectedFirstClassifierId)[0];
            _this._selectedSecondClassifierId = _this._selectedSecondClassifier.getId();
            _this.initializationReady();
        });
    };
    WfPermissionsTwoLevelComponent.prototype.onSave = function (onlyChanged) {
        var _this = this;
        if (!this.saveInProgress) {
            try {
                this.saveInProgress = true;
                this.permissionsByRoleAndAction = this.constructPermissionsByRoleAndAction();
                this.createOrUpdateCategoryConditionalPermissions(onlyChanged).pipe(operators_1.switchMap(function (hasChanged) {
                    if (hasChanged) {
                        var saveMatrix$ = _this.helperService.saveMatrix(_this.category, WfPermissionsTwoLevelComponent_1.toMatrix(_this.permissionsByCondition));
                        var saveKeysMatrix$ = _this.helperService.saveKeysMatrix(_this.category, WfPermissionsTwoLevelComponent_1.toKeysMatrix(_this.permissionKeyByRoleAndAction));
                        return Observable_1.Observable.zip(saveMatrix$, saveKeysMatrix$).pipe(operators_1.catchError(function (err) {
                            _this.showNotification('Error', 'An error occurred while saving permissions');
                            return Observable_1.Observable.throw(err);
                        }), operators_1.map(function () { return true; }));
                    }
                    return Observable_1.Observable.of(false);
                }), operators_1.switchMap(function (hasChanged) {
                    if (hasChanged) {
                        return _this.updateOrganizationWorkflowActionsPermissions(onlyChanged);
                    }
                    return Observable_1.Observable.of(false);
                }), operators_1.switchMap(function (hasChanged) {
                    if (hasChanged) {
                        return _this.updateRolesWorkflowActionsPermissions(onlyChanged);
                    }
                    return Observable_1.Observable.of(false);
                })).subscribe(function () {
                    _this.showNotification('Success', 'Saved!');
                    _this.save.emit();
                });
            }
            catch (e) {
                console.error(e);
                this.showNotification('Error', 'An error occurred while saving permissions');
            }
        }
    };
    WfPermissionsTwoLevelComponent.prototype.onPermissionChange = function (permission, roleId, firstClassifierId, secondClassifierId, actionId) {
        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this.permissionsByCondition, roleId, firstClassifierId, secondClassifierId);
        this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, permission);
        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this._permissionsByConditionChanged, roleId, firstClassifierId, secondClassifierId);
        this._permissionsByConditionChanged.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, true);
    };
    WfPermissionsTwoLevelComponent.prototype.openSetupDialog = function (showFirstClassifier, showSecondClassifier) {
        var _this = this;
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = false;
        dialogConfig.height = 'auto';
        dialogConfig.width = '450px';
        dialogConfig.data = {
            roles: this.roles,
            showFirstClassifier: showFirstClassifier,
            firstClassifiers: this.firstClassifiers,
            firstClassifierLabel: this.firstClassifierLabel,
            showSecondClassifier: showSecondClassifier,
            secondClassifiers: this.secondClassifiers,
            secondClassifierLabel: this.secondClassifierLabel
        };
        this.dialog
            .open(setup_permissions_as_component_1.SetupPermissionsAsComponent, dialogConfig)
            .afterClosed()
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function (result) {
            if (result) {
                var fromRoleId = result.roleId;
                var fromFirstClassifierId = result.fcId;
                var fromSecondClassifierId = result.scId;
                if (showFirstClassifier && showSecondClassifier) {
                    _this.copyBySecondClassifier(fromRoleId, _this.selectedRoleId, fromFirstClassifierId, _this.selectedFirstClassifierId, fromSecondClassifierId, _this.selectedSecondClassifierId);
                    _this.showNotification('Success', 'Copied!');
                }
                else if (showFirstClassifier && !showSecondClassifier) {
                    _this.copyByFirstClassifier(fromRoleId, _this.selectedRoleId, fromFirstClassifierId, _this.selectedFirstClassifierId);
                    _this.showNotification('Success', 'Copied!');
                }
                else if (!showFirstClassifier && !showSecondClassifier) {
                    _this.copyByRole(fromRoleId, _this.selectedRoleId);
                    _this.showNotification('Success', 'Copied!');
                }
            }
        });
    };
    WfPermissionsTwoLevelComponent.prototype.copyByRole = function (fromRoleId, toRoleId) {
        this.resetByRole(toRoleId);
        if (this.permissionsByCondition.has(fromRoleId)) {
            for (var _i = 0, _a = Array.from(this.permissionsByCondition.get(fromRoleId).keys()); _i < _a.length; _i++) {
                var firstClassifierId = _a[_i];
                for (var _b = 0, _c = Array.from(this.permissionsByCondition.get(fromRoleId).get(firstClassifierId).keys()); _b < _c.length; _b++) {
                    var secondClassifierId = _c[_b];
                    for (var _d = 0, _e = Array.from(this.permissionsByCondition.get(fromRoleId).get(firstClassifierId).get(secondClassifierId).keys()); _d < _e.length; _d++) {
                        var actionId = _e[_d];
                        var permission = this.permissionsByCondition.get(fromRoleId).get(firstClassifierId).get(secondClassifierId).get(actionId);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this.permissionsByCondition, toRoleId, firstClassifierId, secondClassifierId);
                        this.permissionsByCondition.get(toRoleId).get(firstClassifierId).get(secondClassifierId).set(actionId, permission);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this._permissionsByConditionChanged, toRoleId, firstClassifierId, secondClassifierId);
                        this._permissionsByConditionChanged.get(toRoleId).get(firstClassifierId).get(secondClassifierId).set(actionId, true);
                    }
                }
            }
        }
    };
    WfPermissionsTwoLevelComponent.prototype.copyByFirstClassifier = function (fromRoleId, toRoleId, fromFirstClassifierId, toFirstClassifierId) {
        this.resetByFirstClassifier(toRoleId, toFirstClassifierId);
        if (this.permissionsByCondition.has(fromRoleId)) {
            if (this.permissionsByCondition.get(fromRoleId).has(fromFirstClassifierId)) {
                for (var _i = 0, _a = Array.from(this.permissionsByCondition.get(fromRoleId).get(fromFirstClassifierId).keys()); _i < _a.length; _i++) {
                    var secondClassifierId = _a[_i];
                    for (var _b = 0, _c = Array.from(this.permissionsByCondition.get(fromRoleId).get(fromFirstClassifierId).get(secondClassifierId).keys()); _b < _c.length; _b++) {
                        var actionId = _c[_b];
                        var permission = this.permissionsByCondition.get(fromRoleId).get(fromFirstClassifierId).get(secondClassifierId).get(actionId);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this.permissionsByCondition, toRoleId, toFirstClassifierId, secondClassifierId);
                        this.permissionsByCondition.get(toRoleId).get(toFirstClassifierId).get(secondClassifierId).set(actionId, permission);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this._permissionsByConditionChanged, toRoleId, toFirstClassifierId, secondClassifierId);
                        this._permissionsByConditionChanged.get(toRoleId).get(toFirstClassifierId).get(secondClassifierId).set(actionId, true);
                    }
                }
            }
        }
    };
    WfPermissionsTwoLevelComponent.prototype.copyBySecondClassifier = function (fromRoleId, toRoleId, fromFirstClassifierId, toFirstClassifierId, fromSecondClassifierId, toSecondClassifierId) {
        this.resetBySecondClassifier(toRoleId, toFirstClassifierId, toSecondClassifierId);
        if (this.permissionsByCondition.has(fromRoleId)) {
            if (this.permissionsByCondition.get(fromRoleId).has(fromFirstClassifierId)) {
                if (this.permissionsByCondition.get(fromRoleId).get(fromFirstClassifierId).has(fromSecondClassifierId)) {
                    for (var _i = 0, _a = Array.from(this.permissionsByCondition.get(fromRoleId).get(fromFirstClassifierId).get(fromSecondClassifierId).keys()); _i < _a.length; _i++) {
                        var actionId = _a[_i];
                        var permission = this.permissionsByCondition.get(fromRoleId).get(fromFirstClassifierId).get(fromSecondClassifierId).get(actionId);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this.permissionsByCondition, toRoleId, toFirstClassifierId, toSecondClassifierId);
                        this.permissionsByCondition.get(toRoleId).get(toFirstClassifierId).get(toSecondClassifierId).set(actionId, permission);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this._permissionsByConditionChanged, toRoleId, toFirstClassifierId, toSecondClassifierId);
                        this._permissionsByConditionChanged.get(toRoleId).get(toFirstClassifierId).get(toSecondClassifierId).set(actionId, true);
                    }
                }
            }
        }
    };
    WfPermissionsTwoLevelComponent.prototype.exportExcel = function () {
        this.exportDataService.exportWfPermissions(this.currentLanguageId, this.category, this._firstClassifierCategory, this._secondClassifierCategory)
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe();
    };
    WfPermissionsTwoLevelComponent.prototype.resetByRole = function (roleId) {
        if (this.permissionsByCondition.has(roleId)) {
            for (var _i = 0, _a = Array.from(this.permissionsByCondition.get(roleId).keys()); _i < _a.length; _i++) {
                var firstClassifierId = _a[_i];
                for (var _b = 0, _c = Array.from(this.permissionsByCondition.get(roleId).get(firstClassifierId).keys()); _b < _c.length; _b++) {
                    var secondClassifierId = _c[_b];
                    for (var _d = 0, _e = Array.from(this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).keys()); _d < _e.length; _d++) {
                        var actionId = _e[_d];
                        var none = new permission_1.Permission('None', '', true, false);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this.permissionsByCondition, roleId, firstClassifierId, secondClassifierId);
                        this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, none);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this._permissionsByConditionChanged, roleId, firstClassifierId, secondClassifierId);
                        this._permissionsByConditionChanged.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, true);
                    }
                }
            }
        }
    };
    WfPermissionsTwoLevelComponent.prototype.resetByFirstClassifier = function (roleId, firstClassifierId) {
        if (this.permissionsByCondition.has(roleId)) {
            if (this.permissionsByCondition.get(roleId).has(firstClassifierId)) {
                for (var _i = 0, _a = Array.from(this.permissionsByCondition.get(roleId).get(firstClassifierId).keys()); _i < _a.length; _i++) {
                    var secondClassifierId = _a[_i];
                    for (var _b = 0, _c = Array.from(this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).keys()); _b < _c.length; _b++) {
                        var actionId = _c[_b];
                        var none = new permission_1.Permission('None', '', true, false);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this.permissionsByCondition, roleId, firstClassifierId, secondClassifierId);
                        this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, none);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this._permissionsByConditionChanged, roleId, firstClassifierId, secondClassifierId);
                        this._permissionsByConditionChanged.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, true);
                    }
                }
            }
        }
    };
    WfPermissionsTwoLevelComponent.prototype.resetBySecondClassifier = function (roleId, firstClassifierId, secondClassifierId) {
        if (this.permissionsByCondition.has(roleId)) {
            if (this.permissionsByCondition.get(roleId).has(firstClassifierId)) {
                if (this.permissionsByCondition.get(roleId).get(firstClassifierId).has(secondClassifierId)) {
                    for (var _i = 0, _a = Array.from(this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).keys()); _i < _a.length; _i++) {
                        var actionId = _a[_i];
                        var none = new permission_1.Permission('None', '', true, false);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this.permissionsByCondition, roleId, firstClassifierId, secondClassifierId);
                        this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, none);
                        WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(this._permissionsByConditionChanged, roleId, firstClassifierId, secondClassifierId);
                        this._permissionsByConditionChanged.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, true);
                    }
                }
            }
        }
    };
    WfPermissionsTwoLevelComponent.prototype.constructPermissionsByRoleAndAction = function () {
        var permissionsByRoleAndAction = new Map();
        for (var _i = 0, _a = Array.from(this.permissionsByCondition.keys()); _i < _a.length; _i++) {
            var roleId = _a[_i];
            for (var _b = 0, _c = Array.from(this.permissionsByCondition.get(roleId).keys()); _b < _c.length; _b++) {
                var firstClassifierId = _c[_b];
                for (var _d = 0, _e = Array.from(this.permissionsByCondition.get(roleId).get(firstClassifierId).keys()); _d < _e.length; _d++) {
                    var secondClassifierId = _e[_d];
                    for (var _f = 0, _g = Array.from(this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).keys()); _f < _g.length; _f++) {
                        var actionId = _g[_f];
                        var permission = this.permissionsByCondition.get(roleId).get(firstClassifierId).get(secondClassifierId).get(actionId);
                        var isChanged = this._permissionsByConditionChanged.has(roleId) &&
                            this._permissionsByConditionChanged.get(roleId).has(firstClassifierId) &&
                            this._permissionsByConditionChanged.get(roleId).get(firstClassifierId).has(secondClassifierId) &&
                            this._permissionsByConditionChanged.get(roleId).get(firstClassifierId).get(secondClassifierId).get(actionId);
                        WfPermissionsTwoLevelComponent_1.preparePermissionsByRoleAndActionMap(permissionsByRoleAndAction, roleId, actionId, new multi_conditional_permission_two_level_1.MultiConditionalPermissionTwoLevel(this.firstClassifierField, this.secondClassifierField));
                        permissionsByRoleAndAction.get(roleId).get(actionId).addConditionalPermission(new conditional_permission_two_level_1.ConditionalPermissionTwoLevel(this.firstClassifierField, firstClassifierId, this.secondClassifierField, secondClassifierId, permission));
                        permissionsByRoleAndAction.get(roleId).get(actionId).setChanged(isChanged);
                    }
                }
            }
        }
        return permissionsByRoleAndAction;
    };
    WfPermissionsTwoLevelComponent.prototype.createOrUpdateCategoryConditionalPermissions = function (onlyChanged) {
        var _this = this;
        var restOperations = [];
        var createdPermissions = [];
        var createdPermissionsProperties = [];
        var updatedPermissions = [];
        for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
            var role = _a[_i];
            for (var _b = 0, _c = this.wfActions; _b < _c.length; _b++) {
                var action = _c[_b];
                if (this.permissionsByRoleAndAction.has(role.id) && this.permissionsByRoleAndAction.get(role.id).has(action.id)) {
                    var conditionalPermission = this.permissionsByRoleAndAction.get(role.id).get(action.id);
                    if (!onlyChanged || (onlyChanged && conditionalPermission.hasChanged())) {
                        WfPermissionsTwoLevelComponent_1.preparePermissionsByRoleAndActionMap(this.permissionKeyByRoleAndAction, role.id, action.id);
                        var permissionKey = this.permissionKeyByRoleAndAction.get(role.id).get(action.id);
                        var expression = conditionalPermission.toExpression(2);
                        var state = this.wfStateByAction.get(action.id);
                        var name_1 = { 7: role.name + ":" + state.name + ":" + action.name };
                        var categoryConditionalPermission = {
                            permissionKey: permissionKey,
                            expression: expression,
                            name: name_1,
                            categorySystemName: this.category,
                            description: "Generated conditional permission to set as permission to do wf action " + action.name + " for role " + role.name,
                            sortId: 999 // we set sortId to 999, to further exclude from options
                        };
                        if (categoryConditionalPermission.permissionKey) {
                            updatedPermissions.push(categoryConditionalPermission);
                        }
                        else {
                            createdPermissions.push(categoryConditionalPermission);
                            createdPermissionsProperties.push({ roleId: role.id, actionId: action.id });
                        }
                    }
                }
            }
        }
        if (updatedPermissions.length) {
            restOperations.push(this.helperService.updateCategoryConditionalPermissions(updatedPermissions));
        }
        if (createdPermissions.length) {
            restOperations.push(this.helperService.createCategoryConditionalPermissions(createdPermissions).pipe(operators_1.map(function (permissionKeys) {
                for (var i = 0; i < permissionKeys.length; i++) {
                    var permissionKey = permissionKeys[i];
                    var properties = createdPermissionsProperties[i];
                    _this.permissionKeyByRoleAndAction.get(properties.roleId).set(properties.actionId, permissionKey);
                }
            })));
        }
        if (restOperations.length) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, restOperations).pipe(operators_1.catchError(function (err) {
                _this.showNotification('Error', 'An error occurred while saving permissions');
                return Observable_1.Observable.throw(err);
            }), operators_1.map(function () { return true; }));
        }
        else {
            return Observable_1.Observable.of(false);
        }
    };
    WfPermissionsTwoLevelComponent.prototype.updateOrganizationWorkflowActionsPermissions = function (onlyChanged) {
        var _this = this;
        var orgActionPermissionKeys = new Map();
        for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
            var role = _a[_i];
            if (!onlyChanged || (onlyChanged && this._permissionsByConditionChanged.has(role.id))) {
                var roleDto = this.rolesMap.get(role.id);
                for (var _b = 0, _c = this.wfActions; _b < _c.length; _b++) {
                    var action = _c[_b];
                    if (this.permissionsByRoleAndAction.has(role.id) && this.permissionsByRoleAndAction.get(role.id).has(action.id)) {
                        if (!orgActionPermissionKeys.has(roleDto.organizationId)) {
                            orgActionPermissionKeys.set(roleDto.organizationId, new Map());
                        }
                        if (!orgActionPermissionKeys.get(roleDto.organizationId).has(action.id)) {
                            orgActionPermissionKeys.get(roleDto.organizationId).set(action.id, []);
                        }
                        orgActionPermissionKeys.get(roleDto.organizationId).get(action.id).push(this.permissionKeyByRoleAndAction.get(role.id).get(action.id));
                    }
                }
            }
        }
        var restOperations = [];
        orgActionPermissionKeys.forEach(function (actionPermissionKey, orgId) {
            restOperations.push(_this.helperService.updateOrganizationPermissions(orgId, actionPermissionKey, _this.wfProcessByAction));
        });
        if (restOperations.length) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, restOperations).pipe(operators_1.catchError(function (err) {
                _this.showNotification('Error', 'An error occurred while saving permissions');
                return Observable_1.Observable.throw(err);
            }), operators_1.map(function () { return true; }));
        }
        else {
            return Observable_1.Observable.of(false);
        }
    };
    WfPermissionsTwoLevelComponent.prototype.updateRolesWorkflowActionsPermissions = function (onlyChanged) {
        var _this = this;
        var restOperations = [];
        for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
            var role = _a[_i];
            if (!onlyChanged || (onlyChanged && this._permissionsByConditionChanged.has(role.id))) {
                var roleDto = this.rolesMap.get(role.id);
                var processId = this.processId;
                var actionPermissionKey = new Map();
                for (var _b = 0, _c = this.wfActions; _b < _c.length; _b++) {
                    var action = _c[_b];
                    if (this.permissionsByRoleAndAction.has(role.id) && this.permissionsByRoleAndAction.get(role.id).has(action.id)) {
                        actionPermissionKey.set(action.id, this.permissionKeyByRoleAndAction.get(role.id).get(action.id));
                    }
                }
                restOperations.push(this.helperService.updateRoleWfPermissions(roleDto, processId, actionPermissionKey, this.wfProcessByAction));
            }
        }
        if (restOperations.length) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, restOperations).pipe(operators_1.catchError(function (err) {
                _this.showNotification('Warning', 'You may not sign that section');
                return Observable_1.Observable.throw(err);
            }), operators_1.map(function () { return true; }));
        }
        else {
            return Observable_1.Observable.of(false);
        }
    };
    WfPermissionsTwoLevelComponent.preparePermissionByConditionMap = function (map, roleId, firstClassifierId, secondClassifierId) {
        if (!map.has(roleId)) {
            map.set(roleId, new Map());
        }
        if (!map.get(roleId).has(firstClassifierId)) {
            map.get(roleId).set(firstClassifierId, new Map());
        }
        if (!map.get(roleId).get(firstClassifierId).has(secondClassifierId)) {
            map.get(roleId).get(firstClassifierId).set(secondClassifierId, new Map());
        }
    };
    WfPermissionsTwoLevelComponent.fromMatrix = function (matrix, permissions) {
        var data = new Map();
        var _loop_1 = function (i) {
            var roleId = matrix[i][0];
            var firstClassifierId = matrix[i][1];
            var secondClassifierId = matrix[i][2];
            var actionId = matrix[i][3];
            var isFull = (matrix[i][4] === 1);
            var isCustom = (matrix[i][4] === 2);
            var permissionKey = matrix[i][5];
            var permission = void 0;
            if (isFull) {
                permission = permissions.find(function (value) { return value.isFull; });
            }
            else if (isCustom) {
                permission = permissions.find(function (value) { return value.permissionKey === permissionKey; });
            }
            if (permission) {
                WfPermissionsTwoLevelComponent_1.preparePermissionByConditionMap(data, roleId, firstClassifierId, secondClassifierId);
                data.get(roleId).get(firstClassifierId).get(secondClassifierId).set(actionId, permission);
            }
        };
        for (var i = 0; i < matrix.length; i++) {
            _loop_1(i);
        }
        return data;
    };
    WfPermissionsTwoLevelComponent.toMatrix = function (data) {
        var matrix = [];
        for (var _i = 0, _a = Array.from(data.keys()); _i < _a.length; _i++) {
            var roleId = _a[_i];
            for (var _b = 0, _c = Array.from(data.get(roleId).keys()); _b < _c.length; _b++) {
                var firstClassifierId = _c[_b];
                for (var _d = 0, _e = Array.from(data.get(roleId).get(firstClassifierId).keys()); _d < _e.length; _d++) {
                    var secondClassifierId = _e[_d];
                    for (var _f = 0, _g = Array.from(data.get(roleId).get(firstClassifierId).get(secondClassifierId).keys()); _f < _g.length; _f++) {
                        var actionId = _g[_f];
                        var permission = data.get(roleId).get(firstClassifierId).get(secondClassifierId).get(actionId);
                        if (permission.isFull) {
                            matrix.push([roleId, firstClassifierId, secondClassifierId, actionId, 1, '']);
                        }
                        else if (permission.isCustom) {
                            matrix.push([roleId, firstClassifierId, secondClassifierId, actionId, 2, permission.permissionKey]);
                        }
                    }
                }
            }
        }
        return matrix;
    };
    Object.defineProperty(WfPermissionsTwoLevelComponent.prototype, "secondClassifiers", {
        get: function () {
            return this._secondClassifiers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfPermissionsTwoLevelComponent.prototype, "permissionsByCondition", {
        get: function () {
            return this._permissionsByCondition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfPermissionsTwoLevelComponent.prototype, "selectedRoleId", {
        get: function () {
            return this._selectedRoleId;
        },
        set: function (value) {
            this._selectedRoleId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfPermissionsTwoLevelComponent.prototype, "selectedFirstClassifierId", {
        get: function () {
            return this._selectedFirstClassifierId;
        },
        set: function (value) {
            this._selectedFirstClassifierId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfPermissionsTwoLevelComponent.prototype, "selectedSecondClassifierId", {
        get: function () {
            return this._selectedSecondClassifierId;
        },
        set: function (value) {
            this._selectedSecondClassifierId = value;
            this._selectedSecondClassifier = this.secondClassifiers.get(this.selectedFirstClassifierId)
                .find(function (classifier) { return classifier.id === value; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfPermissionsTwoLevelComponent.prototype, "selectedSecondClassifier", {
        get: function () {
            return this._selectedSecondClassifier;
        },
        enumerable: true,
        configurable: true
    });
    var WfPermissionsTwoLevelComponent_1;
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WfPermissionsTwoLevelComponent.prototype, "firstClassifierLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WfPermissionsTwoLevelComponent.prototype, "secondClassifierField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WfPermissionsTwoLevelComponent.prototype, "secondClassifierLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], WfPermissionsTwoLevelComponent.prototype, "saveAllButtonIsVisible", void 0);
    WfPermissionsTwoLevelComponent = WfPermissionsTwoLevelComponent_1 = __decorate([
        core_1.Component({
            selector: 'ejustice-wf-permissions-two-level',
            styles: [require('./wf-permissions-two-level.component.css')],
            template: require('./wf-permissions-two-level.component.html'),
            providers: [
                { provide: wf_permissions_helper_service_1.WfPermissionsHelperService, useClass: wf_permissions_helper_service_1.WfPermissionsHelperService }
            ]
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_workflow_service_client_js_1.ActionService,
            idm_workflow_service_client_js_1.StateService,
            idm_workflow_service_client_js_1.ProcessService,
            idm_kb_service_client_js_1.KbService,
            wf_permissions_helper_service_1.WfPermissionsHelperService,
            export_wf_permissions_service_1.ExportWfPermissionsService,
            material_1.MatDialog])
    ], WfPermissionsTwoLevelComponent);
    return WfPermissionsTwoLevelComponent;
}(workflow_base_control_component_1.WorkflowBaseControlComponent));
exports.WfPermissionsTwoLevelComponent = WfPermissionsTwoLevelComponent;
//# sourceMappingURL=wf-permissions-two-level.component.js.map